import { jsxs as S, jsx as n, Fragment as I } from "react/jsx-runtime";
import { memo as R, forwardRef as j } from "react";
import { c as e } from "./index.CWkFp9WS.js";
import { O as c } from "./ODSRow.Du_e7gfN.js";
import { O as L } from "./ODSText.D6mgyggF.js";
import { O as l } from "./ODSIcon.DjL6Q3o4.js";
import '../assets/ODSButton.css';const f = j(
  ({
    buttonType: o = "standard",
    variant: B = "primary",
    size: a = "large",
    disabled: s = !1,
    leftIcon: d = !1,
    rightIcon: N = !1,
    buttonIcon: t,
    label: r,
    ariaLabel: m,
    className: $,
    href: D,
    target: g,
    rel: p,
    onClick: C,
    ...u
  }, h) => {
    const i = o === "link" ? "standard" : o, v = e(
      "ODSButton",
      `ODSButton--size-${a}`,
      `ODSButton--buttonType-${i}`,
      `ODSButton--variant-${B}`,
      {
        "ODSButton--disabled": s
      },
      $
    ), k = e(
      "ODSButton-Content",
      `ODSButton-Content--size-${a}`,
      `ODSButton-Content--buttonType-${o}`
    ), y = e(
      `ODSButton-ButtonBg--variant-${B}`,
      "ODSButton-ButtonBg",
      `ODSButton-ButtonBg--buttonType-${i}`,
      `ODSButton-ButtonBg--size-${a}`,
      {
        "ODSButton-ButtonBg--disabled": s
      }
    ), O = e(
      "ODSButton-ButtonIcon",
      `ODSButton-ButtonIcon--size-${a}`,
      `ODSButton-ButtonIcon--buttonType-${i}`,
      `ODSButton-ButtonIcon--variant-${B}`,
      {
        "ODSButton-ButtonIcon--disabled": s
      }
    ), w = () => u["aria-label"] ? u["aria-label"] : m || r || (t ? `button ${t.split("-").join(" ")}` : "button"), x = o === "link" ? {
      role: "link",
      onClick: () => {
        D && window.open(
          D,
          g ?? "_blank",
          p ?? "noopener,noreferrer"
        );
      }
    } : { onClick: C };
    return /* @__PURE__ */ S(
      "button",
      {
        ref: h,
        type: "button",
        "aria-label": w(),
        className: e(v, y),
        disabled: s,
        ...u,
        ...x,
        children: [
          /* @__PURE__ */ n("div", { className: "ODSButton-ButtonBgElement" }),
          /* @__PURE__ */ n(c, { className: k, children: o === "iconOnly" ? t && /* @__PURE__ */ n(
            l,
            {
              name: t,
              decorative: !0,
              className: O
            }
          ) : /* @__PURE__ */ S(I, { children: [
            d && /* @__PURE__ */ n(
              c,
              {
                className: e(
                  "ODSButton-LeftIcon",
                  `ODSButton-LeftIcon--buttonType-${o}`
                ),
                children: t && /* @__PURE__ */ n(
                  l,
                  {
                    name: t,
                    decorative: !0,
                    className: O
                  }
                )
              }
            ),
            r && /* @__PURE__ */ n(L, { as: "span", className: "ODSButton-Label", children: r }),
            N && /* @__PURE__ */ n(
              c,
              {
                className: e(
                  "ODSButton-RightIcon",
                  `ODSButton-RightIcon--buttonType-${o}`
                ),
                children: t && /* @__PURE__ */ n(
                  l,
                  {
                    name: t,
                    decorative: !0,
                    className: O
                  }
                )
              }
            )
          ] }) })
        ]
      }
    );
  }
);
f.displayName = "ODSButton";
const _ = R(f);
export {
  _ as O
};
//# sourceMappingURL=ODSButton.BmQliYzd.js.map
